import React from 'react'
import PropTypes from 'prop-types'

import MainLayout from '../../layouts/Main'
import { PageTitle } from '../../components'

const HaritonovaPrepravka3View = () => {
    return (
        <MainLayout>
            <div className="row justify-content-center">
                <main className="col-md-12 col-lg-10">
                    <div className="jumbotron">
                        <h1 className="display-4">ТРЕТА ХАРИТОНОВА ПРЕПРАВКА</h1>
                        <p className="lead">НА „ИСТОРИЯ СЛАВЯНОБЪЛГАРСКА“</p>
                    </div>
                    <p>
                        Към ръкописите с близко родство към Компилативната редакция на Паисий Рилски от 1825 г. трябва трябва да бъде
                        отнесена и <strong>Третата Харитонова преправка на „История славянобългарска"</strong>. В бр. 19 на „Църковен
                        вестник" от 19 май 1912 г. са публикувани няколко критикооценъчни статии на живи или вече покойни към онова време
                        видни познавачи на Паисиевото дело. Изданието е юбилейно – посветено на 150-годишнината от съставянето на „История
                        славянобългарска". Сред публикациите откриваме и две анонимни статии, които са озаглавени:
                    </p>
                    <ul>

                        <li>„Граници на българская земля" (Анонимен автор 1912-1: 238 – 239);</li>
                        <li>„Преписи на Паисиевата история" (Анонимен автор 1912-2: 239 – 240). </li>
                    </ul>

                    <p>
                        Първата от публикациите цитира фрагмент за границите на България, разделена на четири части: всяка от тях –
                        съдържаща отделни градове, които са изброени и описани и поименно. Втората статия пък съобщава, че току-що
                        пресъздаденият цитат е зает от ръкопис на Харитон, който представлява препис на Паисиевата история, <strong>датиран
                            към 1832 г.</strong> В същата втора статия се описват и още 8 преписа, познати на анонимния автор, които са
                        представени така:
                    </p>
                    <p>

                        „1) <em>Котленски</em>, снет на 29 януарий 1765 г., в Котел от Стойка Иерея, после епископ Софроний Врачански.
                        Съхранява се в Народната библиотека в София;
                    </p>
                    <p>

                        2) <em>Рилски</em>, снет в 1771 г. В г. Самоковъ от свещ. Алексо Великович Попович и пазен в св. Рилската обител;
                    </p>
                    <p>

                        3) <em>Жеравненски</em>, снет в 1772 год.;
                    </p>
                    <p>

                        4) <em>Дриновски</em>, снет в 1772 год. и съхраняван у наследниците на покойния професор М. Дринов;
                    </p>
                    <p>

                        5) <em>Тошковишки</em>, снет в 1830 г., принадлежи на почетния Одески гражданин Н. С. Тошкович и завещан на г.
                        Калофер;
                    </p>
                    <p>

                        6) Башкьойски, снет в 1842 г. 28 октомврий в с. Башкьой, у Бесарабия, от свещ. Васил Манолов. Притежава го Ив.
                        Икономовъ в г. Тулча;
                    </p>
                    <p>

                        7) <em>Търновски</em>, снет в 1842 год. въ В. Търново от учителите Петко Рачов Славейков и Христо Драганов, в два
                        екземпляра и пазени в Народната библиотека в г. София;
                    </p>
                    <p>

                        8) <em>Шишковски</em>, снет в 1844 год. отъ Теодор Николаевич Шишков и пазен от Н. А. Начов" (Анонимен автор
                        1912-2: 239, курсивът е на автора) .
                    </p>
                    <p>
                        По повод Третата Харитонова преправка анонимният автор съобщава:
                    </p>
                    <p>

                        „Пишещият тия редове има пред себе си и 9-и препис. Този препис е снет от Харитон монах в 1832 г. Месец януарий
                        10-и ден. От този препис са заети статиите <em>„Болгарская земля"</em> и <strong>„<em>Кратка история заради
                                болгарския род",</em></strong> които са поместени на друго място в днешния брой на „Ц. в.". Не се знае само
                        мястото, дето е снеман преписа. Никъде в целия ръкопис не се намира бележка за мястото дето е живял преписвача,
                        когато е снемал преписа. Преписът е подвързан и запазен добре. Само в средата са скъсани четири листа, именно
                        листовете 79, 80, 81 и 82, дето се разправя за Св. Кирил и Методий и покръщението на българите" (Анонимен автор
                        1912-2: 240, курсивът е на автора).
                    </p>
                    <p>
                        На статията „Преписи на Паисиевата история" от анонимния автор от „Църковен вестник" по-късно се позовават Й.
                        Иванов (Иванов 1914: LVII), М. Стоянов (Стоянов 1962: 578), Б. Ст. Ангелов (Ангелов 1966: 62 – 63) и регистрират
                        като изгубена Третата Харитонова преправка, когато описват възрожденските преписи и преправки на „История
                        славянобългарска". „Крехко" съмнение в съществуването на трета преправка от Харитон, оповестено единствено в
                        бележка под линия, за пръв път изразява от Ил. Тодоров (Тодоров 1985: 195 – 196). Едва през юбилейната Паисиева
                        2012 г. трайна усъмненост в действителното някогашно наличие на трети ръкопис, съставен от монах Харитон Рилец,
                        който да възхожда към Паисиевата история, изразява Дарина Караджова. Ще приведа наблюденията ѝ цялостно и цитатно:
                        <strong>и защото</strong> са твърде важни за паспорта на Трета Харитонова преправка; <strong>и защото</strong> ще
                        изразя недоверие спрямо заявеното от авторката. Караджова пише:
                    </p>
                    <p>

                        <em>„Има сведения и за трети, изгубен Харитонов препис от 1832 г., за който не се e знаело къде е преписан. Той е
                            познат от съобщението през 1912 г. на неизвестен анонимен автор (Църковен вестник 1912: 239 – 240). „По тези
                            данни ръкописът е включен в публикации на Маньо Стоянов и Боню Ангелов (Стоянов 1962: 578; Ангелов 1966: 62 –
                            63). Според някои податки обаче в случая вероятно става дума за Първия Змеевски препис на монах Харитон"</em>
                        (Караджова 2012-1: 33).
                    </p>
                    <p>

                        В бележка под линия, съдържаща се в индекс № 2, Д. Караджова доуточнява и още:
                    </p>
                    <p>

                        <em>„Повечето данни на анонимния автор за ръкописа съвпадат с текста на Змеевския препис на монах Харитон от 1831
                            г. На първо място, това е датата на завършването – 10 януари, която е същата и в Змеевския препис. Четирите
                            откъснати листа, обявени погрешно като л. л. 79 – 82, с текста от главата за св. св. Кирил и Методий и
                            покръстването на българите, също съвпадат с четири откъснати, но частично съхранени днес листа от Змеевския
                            препис на монах Харитон, но с друга фолиация (л. л. 69 – 72). В запазените им части дори се вижда текст, от
                            който може да се съди, че става дума именно за същата глава, личи например името на Методий, думи, като
                            „крещени", „латин…" и пр. Освен това в Змеевския препис фигурират и четивата „Болгарская земля" и „Кратка
                            история заради болгарския род" – същите, за които пише и анонимният автор. Предизвиква недоумение твърдението,
                            че „Никъде в целия ръкопис не се намира бележка за мястото, дето е живял преписвачът, когато е снемал преписа,
                            както и съобщената 1832 година. Това може да се обясни единствено с някакво недоглеждане на името на селището и
                            объркване на годината, може би печатна грешка (каквито се срещат в цитираното периодично издание) и това
                            анонимно съобщение би трябвало да се приеме всъщност като публикация за известния препис на монах Харитон,
                            извършен в Змеево през 1831 г. Между другото, грешка по отношение на датировката на същия ръкопис прави и
                            старозагорският учител Георги П. Русески, според когото годината е 1836-а. Той описва по памет данните за
                            намерения от него книжовен паметник в едно свое писмо до Васил Златарски от 1899 г., в което съобщава, че
                            ръкописът е бил у него за кратко време (Архив Златарски: а. е. 917). За писмото вж. и по-нататък в инд. 5</em>"
                        (Караджова 2012-1: 3).<em> </em>
                    </p>
                    <p>

                        В бележката с индекс № 5, към която отпраща авторката, четем:
                    </p>
                    <p>

                        <em>„В писмото си до Васил Златарски Георги Русески споменава, че поради възрастта си през 1886 г. не е заминал
                            войник в сръбско-българската война. Останал е в Стара Загора, където по причина на войната училището било
                            затворено за 8 месеца. Независимо от тези събития, през м. януари му предложили да издаде препис на Паисиевата
                            история с условие да заплати един златен наполеон на притежателя му Иван Кряката от махала Акарджа. Без да види
                            ръкописа, Г. Русески отначало отказал, тъй като от 5 месеца не бил получавал заплата. После го закупил, но го
                            препродал на известния български историк от Стара Загора Никола Начов. От писмото му се разбира, че преписът е
                            бил направен през 1836 г. от йеромонах Харитон в село Змеево и че в приписката на книжовника се съдържали
                            подробни данни и за месеца и деня на изписването. Освен това в ръкописа липсвали 7 листа от статията за св. св.
                            Кирил и Методий. Откъснатите листовете в оригинала обаче са всъщност осем, заедно с четирите, частично
                            запазени, по които, както вече се спомена по-горе, бележка 2, личат отделни думи, свързани с главата за Светите
                            братя. Днес могат да се видят следите и от тези листове, които изцяло липсват (л. 73, 74, 75, 76). За нас не е
                            ясно откъде идва сгрешената година на Змеевския Харитонов препис. Писмото възпроизвежда случая отпреди 13
                            години, ръкописът вече не е бил у Г. Русески и по тази причина е допустимо да се появят неточности в
                            предаването на годината в цитираните по памет данни от страна на възрастния учител. Между другото, началната
                            буква на името на селището е изписана със S и е възможно да е оказала влияние известна асоциация с числовата ѝ
                            стойност за 6, откъдето и годината да е припомнена погрешно като 1836-а. Ясно е, че и в този случай става дума
                            за Змеевския Харитонов препис от 1831 г." </em>(Караджова 2012-1: 39).
                    </p>
                    <p>
                        На читателят, който не познава отблизо палеографията на ръкописа, от така изложеното от Даринка Караджова не му
                        става съвсем ясно колко точно са откъснатите листа в Първата Харитонова преправка: дали са 4, или са 7, или пък 8.,
                        едва ли ще получи еднозначен отговор за действителните липси в него. За тези липси обаче коректно съобщават двама
                        от притежателите на Първата Харитонова преправка. Като я описва в писмото си, което Караджова цитира, Георги
                        Русески документира и още:
                    </p>
                    <p>

                        <em>„Тук в статията на св. Кирила и Методия по изнамерванието буквите и писмеността от тях, имаше до 7 листа или 14
                            стр. скъсани, та най-важното по тоя въпрос беше в неизвестност"</em> (Архив на БАН № 9, а. е. 917: 2а).
                    </p>
                    <p>
                        За повече от 4 откъснати листа свидетелства и Никола Начов:
                    </p>
                    <p>

                        <em>„Ръкописът, пренесен отъ Змеево въ Ст.-Загора билъ честитъ да оцелее пряз катастрофата в тоя град на 1877 г.;
                            само л. 69 – 77 са одрани"</em> (Начов 1894: 513).
                    </p>
                    <p>
                        И още:
                    </p>
                    <p>

                        „<em>Отъ статията за Кирила и Методия въ нашия ркп. се е зачувало само зачалото</em> (л. 67б – 68б)" (Начов 1894:
                        517).
                    </p>
                    <p>
                        Както е видно, описаното и от Г. Русески, и от Н. Начов категорично не съвпада с известието на анонимния автор на
                        статията от 1912 г. за откъснати 4 листа от преправката от 1832 г. Това би следвало да означава еднозначно, <strong>че
                            Първата Харитонова преправка и Третата Харитонова преправка имат различен брой откъснати листа, а това на свой
                            ред би трябвало да доказва, че не можем да говорим за припокриване на ръкописите и за допусната грешка от
                            анонимния автор. </strong>
                    </p>
                    <p>
                        Не ме убеждават доводите на Д. Караджова и за сгрешена времепоява на изгубения днес ръкопис. Приемам, че ако в
                        ръкописа е имало обозначение на година, то анонимният автор е щял да го види, защото е ясно, че той не е
                        некомпетентен при представянето на ръкописните възрожденски книги, анонимната статия убеждава читателя, че авторът
                        ѝ е задълбочен познавач на преписите на „История славянобългарска" и знае как се описва важното от „паспортните"
                        данни на оригиналите. Ако се позовем и на дейността на Харитон Рилец, в която преписвачеството на ръкописни книги
                        заема основополагащо място, ще можем да приемем, че <strong>не е невъзможно да е съставил и този трети препис</strong>.
                        Над него монахът вероятно е работил непосредствено след съставянето на Втората Харитонова преправка. Колкото до
                        съвпаденията на датите (10 януари 1831 г. и 10 януари 1832 г.), то ще подскажа на читателя, че Харитон е почитал
                        празниците от православния календар, затова отново по празниците е завършил и този свой ръкопис.
                    </p>
                    <p>
                        Не приемам за правдоподобно и позоваването на Караджова:
                    </p>
                    <p>

                        <em>„Освен това в Змеевския препис фигурират и четивата „Болгарская земля" и „Кратка история заради болгарския род"
                            – същите, за които пише и анонимният автор". </em>
                    </p>
                    <p>
                        Специалистите знаят, че и двата цитирани раздела се съдържат не само в Първата Харитонова преправка, но ги има и
                        във Втората преправка. Съвсем логично е да са се съдържали и в Третата преправка, защото неин съставител отново е
                        Харитон, а при преписа ѝ той вероятно е ползвал една от двете предхождащи я преправки: или Първата Харитонова
                        преправка; или Втората Харитонова преправка. Оттук е и съвпадението между съдържанието на ръкописите на първия и
                        третия препис на Харитон. Хипотезата, която застъпвам, следователно настоява, че Харитон действително е съставил и
                        Трета преправка на „История славянобългарска", над която е работил по време на коледните празници през 1832 г.
                        Когато преправката все още е била налична, от оригинала са били откъснати листовете от 79 до 82, разказващи за
                        делото на Кирил и Методий и за покръстването на българите. Както е видно, няма съвпадение между откъснатите листа в
                        Първата и Третата Харитонова преправка. Третата Харитонова преправка съдържа статиите „Болгарская земля" и „Кратка
                        история заради болгарския род", така, както ги съдържат и Първата Харитонова преправка, и Втората Харитонова
                        преправка. Това ме навежда на мисълта, че за неин пряк извод е послужил един от двата предишни Харитонови ръкописа.
                        Изчезването на ръкопис не е необичайно явление, характеризиращо възрожденските преписи и преправки на Паисиевата
                        история.
                    </p>
                    <p>
                        За трайните интереси на монах Харитон Рилец към ръкописната книга свидетелстват трите му преписи на Паисиевата
                        история. Тъй като съществува вероятност Харитон да е живял повече от седемдесет години, може да е оставил и други
                        преправки на Паисиевата история, които, ако ги е имало, също не са запазени. Дали е съставил и други ръкописи по
                        Паисиевата история, може би ние, Харитоновите следовници, няма никога да узнаем, но пък днес категорично знаем, че
                        няма друг български възрожденец, който да е преписвал три поредни пъти „История славянобългарска", а това е
                        достатъчно красноречиво свидетелство за почитта му към „Паисиада" и духовните ценности на Българската възрожденска
                        култура.
                    </p>
                    <p className="text-center">© Автор: доц. д-р Мила Кръстева<br/>
                    Пловдив, 19.07.2018 г.</p>
                </main>
            </div>
        </MainLayout>
    )
}

HaritonovaPrepravka3View.propTypes = {
    
}

export default HaritonovaPrepravka3View



// WEBPACK FOOTER //
// ./src/views/HaritonovaPrepravka3/index.js